import { render, staticRenderFns } from "./DataPoint.vue?vue&type=template&id=e85e6e6c"
import script from "./DataPoint.vue?vue&type=script&lang=js"
export * from "./DataPoint.vue?vue&type=script&lang=js"
import style0 from "./DataPoint.vue?vue&type=style&index=0&id=e85e6e6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports